<template>
  <div>
    <the-header/>
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'Public',
  components: {
    TheHeader: () => import('../components/TheHeader.vue'),
  },
};
</script>
